export default __webpack_public_path__ + "static/weare-1-639ccc75e38d4e06235b2fa82a0f33b0.png";